module.exports = __webpack_public_path__ + "img/avatar.e49e01b1.png";